export default __webpack_public_path__ + "static/media/tokopedia.c7274d30.svg";